import { User } from "../../shared/types";

const getShippingAddress = (user: User): string => {
  if (!user || !user.shippingAddress || !user.shippingAddress.address) {
    return "";
  }

  const { address, postCode, city } = user.shippingAddress.address;

  const userShippingAddress = [address, postCode, city].filter((removeEmpties) => removeEmpties);

  return userShippingAddress.join(", ");
};

export { getShippingAddress };
